import { Box, Button, ButtonProps, makeStyles } from '@material-ui/core';

import { Font } from '@/components/shared/components/Font';
import { MoreActionsMenu } from '@/components/shared/components/MoreActionsMenu/MoreActionsMenu';
import { ActionsOption } from '@/components/shared/components/MoreActionsMenu/types/ActionsOption';
import { Text } from '@/components/shared/components/Text';

interface SelectMenuWithIconProps {
  optionsArray: ActionsOption[];
  titleTextId: string;
  iconName?: string;
  buttonProps?: ButtonProps;
}

export const SelectMenuWithIcon = ({ optionsArray, iconName, titleTextId, buttonProps }: SelectMenuWithIconProps) => {
  const useStyles = makeStyles({
    root: {
      '&.MuiButton-sizeSmall': {
        height: '26px',
      },
    },
  });

  const classes = useStyles();

  return (
    <MoreActionsMenu actionsOptionsArray={optionsArray}>
      <Button className={classes.root} size={'small'} variant={'outlined'} {...buttonProps}>
        <Font
          variant={'caption'}
          color={'textSecondary'}
          style={{ display: 'inline-flex', alignItems: 'center', fontWeight: 500 }}
        >
          {iconName && (
            <i
              className={'material-icons-outlined mr-2'}
              style={{ verticalAlign: '-5px', marginLeft: '-4px', fontSize: '16px' }}
            >
              {iconName}
            </i>
          )}
          <Box className="overflow-text-ellipsis" maxWidth={'120px'}>
            <Text tId={titleTextId} />
          </Box>
          {iconName && (
            <i
              className={'material-icons-outlined'}
              style={{ verticalAlign: '-5px', marginLeft: '4px', fontSize: '1.5em' }}
            >
              {'expand_more'}
            </i>
          )}
        </Font>
      </Button>
    </MoreActionsMenu>
  );
};
